import { render, staticRenderFns } from "./reportedProbableGen.vue?vue&type=template&id=e8672824&scoped=true&"
import script from "./reportedProbableGen.vue?vue&type=script&lang=js&"
export * from "./reportedProbableGen.vue?vue&type=script&lang=js&"
import style0 from "./reportedProbableGen.vue?vue&type=style&index=0&id=e8672824&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8672824",
  null
  
)

export default component.exports